/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Whatwedo_Analytics2Inputs */

const ja_careers_whatwedo_analytics2 = /** @type {(inputs: Careers_Whatwedo_Analytics2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブ配信のデータ分析`)
};

const en_careers_whatwedo_analytics2 = /** @type {(inputs: Careers_Whatwedo_Analytics2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streaming Analytics`)
};

/**
* | output |
* | --- |
* | "Streaming Analytics" |
*
* @param {Careers_Whatwedo_Analytics2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_whatwedo_analytics2 = /** @type {((inputs?: Careers_Whatwedo_Analytics2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Whatwedo_Analytics2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_whatwedo_analytics2(inputs)
	return en_careers_whatwedo_analytics2(inputs)
});
export { careers_whatwedo_analytics2 as "careers_whatWeDo_analytics" }